




import Vue from 'vue'
import Component from 'vue-class-component'
import { Action, Getter } from 'vuex-class'
import validateEmail from '@/validateEmail'

@Component({
})
export default class SendEmail extends Vue {
  @Action private sendEmail!: () => Promise<void>
  @Getter private settingSave!: string
  @Getter private settingCompare!: string
  @Getter private settingFinanceAreas!: string[]
  @Getter private settingConsent!: string
  @Getter private email!: string

  validate () {
    const validValues = ['true', 'false']
    if (!validateEmail(this.email)) {
      return false
    }
    if (!validValues.includes(this.settingSave)) {
      return false
    }
    if (!validValues.includes(this.settingCompare)) {
      return false
    }
    if (this.settingFinanceAreas.join(',') === '') {
      return false
    }
    if (this.settingConsent !== 'true') {
      return false
    }

    return true
  }

  async mounted (to: any, from: any, next: (route?: string) => void) {
    if (!(this as any).validate()) {
      alert('Please fill out all fields in order to receive an email')
      this.$router.replace('email')
      return
    } else {
      await this.sendEmail()
      this.$router.replace('email_done')
    }
  }
}
